export const INCOMPLETE_CHUNK_RECOVERY_TITLE = "Recover interrupted recording?";

export const INCOMPLETE_CHUNK_RECOVERY_MESSAGE =
  "This recording ended before its upload was finalized. Recover and process all audio chunks that were saved successfully?";

type RecoverableAudioMetadata = {
  is_uploaded: boolean;
  upload_mode?: "single_blob" | "chunked_resumable";
  upload_status?: string;
};

export const shouldOfferIncompleteChunkRecovery = (
  audio: RecoverableAudioMetadata,
): boolean =>
  !audio.is_uploaded &&
  audio.upload_mode === "chunked_resumable" &&
  audio.upload_status === "uploading_parts";
